var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReportNotSubmitted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#B14F22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99972 10.2857C7.51401 10.2857 7.14258 9.91425 7.14258 9.42854V3.99997C7.14258 3.51425 7.51401 3.14282 7.99972 3.14282C8.48544 3.14282 8.85686 3.51425 8.85686 3.99997V9.42854C8.85686 9.91425 8.48544 10.2857 7.99972 10.2857Z",
    fill: "#B14F22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85686 12C8.85686 12.4857 8.48544 12.8571 7.99972 12.8571C7.51401 12.8571 7.14258 12.4857 7.14258 12C7.14258 11.5143 7.51401 11.1428 7.99972 11.1428C8.48544 11.1428 8.85686 11.5143 8.85686 12Z",
    fill: "#B14F22"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportNotSubmitted);
export default __webpack_public_path__ + "static/media/icon-report-not-submitted.29af13b774b4fe700def8027c33902cd.svg";
export { ForwardRef as ReactComponent };